var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullhorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.5 21C22.5 21.4219 22.1719 22.5 21 22.5C20.7188 22.5 20.2969 22.3594 20.0625 22.1719L16.0781 18.9844C14.4844 17.7188 12.5156 16.9219 10.5 16.6406V5.85938C12.5156 5.57812 14.4844 4.78125 16.0781 3.51562L20.0625 0.328125C20.3438 0.09375 20.6719 0 21 0C22.1719 0 22.5 1.07812 22.5 1.5V21Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 7.35938 1.35938 6 3 6H9C9.51562 6 9.98438 5.95312 10.5 5.85938V16.6406C9.98438 16.5469 9.51562 16.5 9 16.5H8.71875C8.15625 18.7031 10.0312 21 10.0781 21C10.5 21.5156 10.6406 22.2656 10.4062 22.9219C10.1719 23.5781 9.60938 24 9 24H6C5.53125 24 5.10938 23.7656 4.82812 23.3438C4.82641 23.3412 4.82401 23.3376 4.82097 23.3331C4.65795 23.0913 2.63445 20.0893 3.14062 16.5H3C1.35938 16.5 0 15.1406 0 13.5V9ZM24 11.25C24 12.375 23.3906 13.3125 22.5 13.8281V8.67188C23.3906 9.1875 24 10.125 24 11.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn);
export default __webpack_public_path__ + "static/media/bullhorn.dcdbfabb6aa55aa363fc797927705b21.svg";
export { ForwardRef as ReactComponent };